import { render, staticRenderFns } from "./ProvinceCocTypeAnalysis.vue?vue&type=template&id=045ee422&scoped=true"
import script from "./ProvinceCocTypeAnalysis.vue?vue&type=script&lang=js"
export * from "./ProvinceCocTypeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProvinceCocTypeAnalysis.vue?vue&type=style&index=0&id=045ee422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ee422",
  null
  
)

export default component.exports